import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "plus",
  "use": "plus-usage",
  "viewBox": "0 0 500 500",
  "content": "<symbol viewBox=\"0 0 500 500\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"plus\">\n\n<path d=\"M264.062 25H235.938V475H264.062V25Z\" fill=\"currentColor\" />\n<path d=\"M25 235.938V264.062H475V235.938L25 235.938Z\" fill=\"currentColor\" />\n\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol